<template>
  <div class="content">
    <div class="statistic-panel">
      <el-row>
        <el-col :xs="12" :sm="6" class="statistic-item text-center">
          <div>
            <div>
              <i class="material-icons assess-color">assessment</i>
            </div>
            <div>
              <translate>Resource</translate>
              <br/>
              <span class="count assess-color">{{statistic.resources + statistic.shared_resources || 0}}</span>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" class="statistic-item text-center">
          <div>
            <div>
              <i class="material-icons work-color">dvr</i>
            </div>
            <div>
              <translate>WorkGroup</translate>
              <br/>
              <span class="count work-color">{{statistic.projects || 0}}</span>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" class="statistic-item text-center">
          <div>
            <div>
              <i class="material-icons cluster-color">view_list</i>
            </div>
            <div>
              <translate>Cluster</translate>
              <br/>
              <span class="count cluster-color">{{statistic.networks || 0}}</span>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" class="statistic-item text-center">
          <div>
            <div>
              <i class="material-icons member-color">group</i>
            </div>
            <div>
              <translate>Member</translate>
              <br/>
              <span class="count member-color">{{statistic.accounts || 0}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="graph-panel">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="10" :lg="10">
          <div class="graph-item">
            <div class="graph-item-header">
              <translate>Resource Type</translate>
            </div>
            <div class="graph-item-content chart" v-loading="reTypeLoading">
              <div v-if="!resourceType && !reTypeLoading" style="text-align: center; margin-top: 110px"><translate>No Resource Type</translate></div>
              <nvd3-pie-chart v-if="resourceType && !reTypeLoading" :options="resourceType.options" :data="resourceType.data"></nvd3-pie-chart>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="14" :lg="14">
          <div class="graph-item">
            <div class="graph-item-header">
              <translate>A Week Operation Statistic</translate>
            </div>
            <div class="graph-item-content chart" v-loading="!weekOperation">
              <nvd3-line-chart v-if="weekOperation" :options="weekOperation.options" :data="weekOperation.data"></nvd3-line-chart>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="graph-panel">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <div class="graph-item" :class="currentConnectCount > 10 ? 'graph-item-210' : ''">
            <div class="graph-item-header">
              <translate>Online Sessions</translate>
            </div>
            <div class="graph-item-content">
              <el-table stripe :data="currentConnectList" style="width: 100%" :empty-text="attrText.noSession" v-loading="!currentConnectList">
                <el-table-column prop="account.name" :label="attrText.member" width="120">
                  <template scope="scope">
                    {{!scope.row.account ? '' : scope.row.account.name}}
                  </template>
                </el-table-column>
                <el-table-column width="50" label=" ">
                  <template scope="scope">
                    <el-tooltip class="item" effect="dark" :content="attrText.unsafeMode" placement="top" v-if="!scope.row.safe_mode">
                      <i class="fa fa-exclamation-circle warn"></i>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="project_name" :label="attrText.workgroup"> </el-table-column>
                <el-table-column prop="resource_name" :label="attrText.resource"> </el-table-column>
                <el-table-column :label="attrText.action" width="200">
                  <template scope="scope">
                    <el-button :disabled="!scope.row.linkHref || !(scope.row.way=='terminal' || scope.row.way=='wetty' || (scope.row.way=='rdp' && scope.row.showRdp))"
                                @click="onLinkhref(scope.row.linkHref)"
                                type="text"
                                v-if="scope.row.agentVersion < '3.0.0'"
                                target="_blank">
                      <translate>Monitor</translate>
                    </el-button>
                    <el-button :disabled="!(scope.row.way=='terminal' || scope.row.way=='wetty' || (scope.row.way=='rdp' && scope.row.showRdp))"
                                type="text"
                                v-if="scope.row.agentVersion >= '3.0.0'"
                                target="_blank">
                      <span v-if="scope.row.way==='terminal' || scope.row.way==='wetty'"  @click="createShadow(scope.row)"><translate>assistance</translate></span>
                      <span v-if="(scope.row.way==='rdp' && scope.row.showRdp)"  @click="onLinkhref(scope.row.linkHref)"><translate>monitor</translate></span>
                    </el-button>
                    <el-button type="text" @click="onCutOnline(scope.row)"><translate>Disconnect</translate></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="pagination" v-if="currentConnectCount > 10">
                <el-pagination layout="total, prev, pager, next" :total="currentConnectCount" :page-size="10"
                                :current-page.sync="currentConnectPage" @current-change="onChangePage"></el-pagination>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6">
          <div class="graph-item">
            <div class="graph-item-header">
              <translate>A Week TOP Member</translate>
            </div>
            <div class="graph-item-content">
              <el-table stripe :data="topMembers" style="width: 100%" v-loading="!topMembers">
                <el-table-column :label="attrText.member">
                  <template scope="props">
                    <span class="photo clearfix">
                      <img :src="props.row.avatar | resetURL" border="0"/>
                      <span>{{ props.row.name }}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column :label="attrText.duration" width="110" class-name="text-right" label-class-name="text-right">
                  <template scope="scope">
                    {{ scope.row.conn_time }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6">
          <div class="graph-item">
            <div class="graph-item-header">
              <translate>A Week TOP Resource</translate>
            </div>
            <div class="graph-item-content">
              <el-table stripe :data="topResources" style="width: 100%" v-loading="!topResources">
                <el-table-column prop="name" :label="attrText.resource" min-width="100px"> </el-table-column>
                <el-table-column prop="conn_count" :label="attrText.number" class-name="text-right" label-class-name="text-right"></el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import STORE_CONST from '../../store/consts'
import Nvd3PieChart from '../common/nvd3-pie-chart'
import Nvd3LineChart from '../common/nvd3-line-chart'
import Base64 from 'js-base64'
import { baseUrl } from '../../config'
import Utility from '../../Utils'

export default {
  name: 'Dashboard',
  data () {
    return {
      xAxis: [],
      weekOperation: null,
      reTypeLoading: true,
      resourceType: null,
      statistic: {},
      topMembers: null,
      topResources: null,
      emptyData: true,
      currentConnectList: null,
      currentConnectPage: 1
    }
  },
  computed: {
    // currentConnectList () {
    //   return this.$store.getters.dashboard.onlineMembers
    // },
    currentConnectCount () {
      return this.$store.getters.dashboard.onlineMembersCount
    },
    attrText () {
      return this.getTranslateText()
    },
    languageCurrent () {
      return this.$language.current
    }
  },
  created () {
    if (Object.keys(this.$store.getters.account).length && this.$store.getters.account.is_admin) {
      this.$router.push('/dashboard')
      sessionStorage.setItem('activeIndex', '1-1')
      this.getStatistics()
      this.getWeekOperationStatistic()
      this.getResourceTypeStatistic()
      this.getTopMembers()
      this.getTopResources()
      this.getOnlineConnects()
    } else {
      this.$router.push('/operation/workgroup')
      sessionStorage.setItem('activeIndex', '1-2')
    }
  },
  mounted () {
  },
  methods: {
    getTranslateText () {
      return {
        member: this.$gettext('Member'),
        cluster: this.$gettext('Cluster'),
        workgroup: this.$gettext('Workgroup'),
        duration: this.$gettext('Duration/minute'),
        number: this.$gettext('Number'),
        resource: this.$gettext('Resource'),
        action: this.$gettext('Action'),
        noSession: this.$gettext('no online sessions'),
        'unsafeMode': this.$gettext('Unsafe Mode')
      }
    },
    onLinkhref (url) {
      if (url) {
        window.open(url)
      }
    },
    createShadow (con) {
      let params = {
        master_connection_id: con.connection_id,
        readonly: false,
        expire_time: Math.floor(new Date().getTime() / 1000) + 30 * 60
      }
      var newWin = window.open('')
      this.$store.dispatch(STORE_CONST.WORKGROUP.GET_CSOS_SHADOW, params).then(res => {
        let shadowUrl = 'http://' + res.agent_host + ':' + res.agent_webtty_port + '/?code=' + Base64.Base64.encode(res.code) + '&user=' + res.user
        newWin.location.href = shadowUrl
      }, () => {
        newWin.close()
      })
    },
    getWeekOperationChartOptions (chartData) {
      const colors = ['#529AFC', '#A2F1AF']
      const totalChartData = {
        options: {
          chart: {
            showLegend: true,
            showControls: false,
            showYAxis: false,
            showMinMaxPoints: false,
            height: 300,
            margin: {
              top: 20,
              right: 30,
              bottom: 40,
              left: 40
            },
            x: (d) => d.x,
            y: (d) => d.y,
            useInteractiveGuideline: true,
            xAxis: {
              showMaxMin: false,
              tickFormat: (d, index) => {
                const date = new Date(this.xAxis[d])
                return date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate()
              }
            },
            yAxis: {
              showMaxMin: false,
              tickFormat: (d) => {
                return d
              }
            }
          }
        },
        data: [
        ]
      }
      chartData.forEach((item, index) => {
        totalChartData.data.push({
          values: item,
          key: index === 0 ? this.$gettext('Number of Connections/number') : this.$gettext('Duration of Connections/hour'),
          color: colors[index],
          area: true
        })
      })
      return totalChartData
    },
    getWeekOperationStatisticData (data) {
      let chartDataTotal = []
      let chartDataTimeLen = []
      /* 旧版本
      let totalData = data
      totalData.sort((a, b) => {
        return new Date(a.time.replace(/-/g, '/') + ' 00:00:00').getTime() - new Date(b.time.replace(/-/g, '/') + ' 00:00:00').getTime()
      })
      */
      data.forEach((item, index) => {
        item._time = new Date(item.date.replace(/-/g, '/') + ' 00:00:00').getTime()
        this.xAxis.push(item._time)
        chartDataTotal.push({
          x: index,
          xLabel: item._time,
          y: item.conn_count
        })
        chartDataTimeLen.push(
          {
            x: index,
            xLabel: item._time,
            y: (item.conn_time / 3600).toFixed(2)
          }
        )
      })
      return [chartDataTotal, chartDataTimeLen]
    },
    getWeekOperationStatistic () {
      let dataLen = 7
      let currentDate = new Date()
      let year = currentDate.getFullYear()
      let month = (currentDate.getMonth() + 1) < 10 ? '0' + (currentDate.getMonth() + 1) : '' + (currentDate.getMonth() + 1)
      let date = currentDate.getDate() < 10 ? '0' + currentDate.getDate() : currentDate.getDate()
      let endDate = new Date(year + '/' + month + '/' + date + ' 23:59:59')
      let startDate = new Date(endDate.getTime() - (dataLen * 24 * 60 * 60 * 1000 - 1000))
      const params = {
        time_from: Math.floor(startDate.getTime() / 1000),
        time_end: Math.floor(endDate.getTime() / 1000)
      }
      this.$store.dispatch(STORE_CONST.DASHBOARD.GET_OPERATION_WEEK, params).then(res => {
        console.log('一周运维统计：', this.getWeekOperationStatisticData(res))
        this.weekOperation = this.getWeekOperationChartOptions(this.getWeekOperationStatisticData(res))
      })
    },
    getResourceTypeChartOptions (data) {
      const chartData = {
        options: {
          chart: {
            showLegend: false,
            donut: true,
            x: (d) => d.key,
            y: (d) => d.y,
            showTooltipPercent: true,
            labelsOutside: true,
            valueFormat: (d) => d
          }
        },
        data: data
      }
      return chartData
    },
    getResourceTypeStatistic () {
      this.reTypeLoading = true
      this.$store.dispatch(STORE_CONST.DASHBOARD.GET_RESOURCE_TYPE_STATISTIC).then(res => {
        console.log('get resource type statistic: ', res)
        if (res) {
          let chartData = []
          Object.forEach(res, (val, key) => {
            if (val > 0) {
              this.emptyData = false
            }
            if (key === 'mssql') {
              chartData.push({
                key: 'SQL Server',
                y: val
              })
            }
            if (key === 'oracle') {
              chartData.push({
                key: 'Oracle',
                y: val
              })
            }
            if (key === 'mysql') {
              chartData.push({
                key: 'MySQL',
                y: val
              })
            }
            if (key === 'linux') {
              chartData.push({
                key: 'Linux',
                y: val
              })
            }
            if (key === 'win32') {
              chartData.push({
                key: 'Windows',
                y: val
              })
            }
          })
          if (!this.emptyData) {
            this.resourceType = this.getResourceTypeChartOptions(chartData)
          }
          this.reTypeLoading = false
        }
      })
    },
    getStatistics () {
      this.$store.dispatch(STORE_CONST.DASHBOARD.GET_STATISTICS).then(res => {
        console.log('dashboard Number', res)
        this.statistic = res
      })
    },
    getTopMembers () {
      this.$store.dispatch(STORE_CONST.DASHBOARD.LIST_TOP_MEMBERS, this.getTopRequestParams()).then(res => {
        let topMembers = Object.clone(res)
        topMembers.forEach((item) => {
          /*
          // 精确到分钟 旧版本
          item.totalTime = 0
          if (item.results) {
            item.results.forEach((timeItem) => {
              item.totalTime += timeItem.value.time_long
            })
            if (Math.round(item.totalTime / 60) === 0) {
              item.totalTime = (item.totalTime / 60).toFixed(2)
            } else {
              item.totalTime = Math.round(item.totalTime / 60)
            }
          }
          */
          // v1版本
          if (Math.round(item.conn_time / 60) === 0) {
            item.conn_time = (item.conn_time / 60).toFixed(2)
          } else {
            item.conn_time = Math.round(item.conn_time / 60)
          }
        })
        this.topMembers = topMembers.splice(0, 10)
      }, () => {
        this.topMembers = []
      })
    },
    getTopResources () {
      this.$store.dispatch(STORE_CONST.DASHBOARD.LIST_TOP_RESOURCES, this.getTopRequestParams()).then(res => {
        let topResources = Object.clone(res)
        this.topResources = topResources.splice(0, 10)
      }, () => {
        this.topResources = []
      })
    },
    getTopRequestParams () {
      const currentDate = new Date()
      const beforeWeekDate = new Date(currentDate.getTime() - 7 * 24 * 3600 * 1000)
      return {
        time_from: parseInt(beforeWeekDate.getTime() / 1000),
        time_end: parseInt(currentDate.getTime() / 1000),
        period: 'day'
      }
    },
    // 在线用户分页改变
    onChangePage (pageIndex) {
      this.currentConnectPage = pageIndex
      this.getOnlineConnects(pageIndex)
    },
    // --- start 获取在线用户列表 ---
    getOnlineConnects (page) {
      this.currentConnectPage = page || 1
      const params = {
        page: page || 1
      }
      this.$store.dispatch(STORE_CONST.DASHBOARD.GET_ONLINE_CONNECT, params).then((res) => {
        if (res && res.length) {
          let _connectList = Object.clone(res)
          _connectList.forEach((item, index) => {
            let linkHref = ''
            if (item.guacamole && item.guacamole === 1) { // gucamole 类型的rdp 监视
              linkHref = 'http://' + item.host + ':' + item.webrdp_port + '/?code=' + Base64.Base64.encode(item.tunnel_code) + '&ip=' + item.resource_ip_address + '&resourceName=' + item.resource_name
            } else { // 旧的类型的rdp 以及 terminal 类型
              linkHref += 'playlog.html'
              linkHref += '?link=' + baseUrl.apiUrl
              linkHref += '&way=' + item.way
              linkHref += '&code=' + item.tunnel_code
              linkHref += '&lang=' + this.languageCurrent
              linkHref += '&type=monitor'
            }
            if (item.connection_id) {
              linkHref += '&connection_id=' + item.connection_id
            }
            item.linkHref = linkHref
            let showRdp = false
            if (item.agent_version) {
              item.noResourceDisabled = false
              if (Utility.Utils.getAgentVersion(item.agent_version) >= '2.4.2') {
                showRdp = true
              }
              item.agentVersion = Utility.Utils.getAgentVersion(item.agent_version)
            }
            item.showRdp = showRdp
          })
          this.currentConnectList = _connectList
          console.log('connects------->+', this.currentConnectList)
        } else {
          this.currentConnectList = []
        }
      })
    },
    // --- end 获取在线用户列表 ---
    // 断开连接
    onCutOnline (item) {
      this.$confirm(this.$gettext('Are you sure to disconnect this connection?'), this.$gettext('Disconnect connection confirm'), {
        confirmButtonText: this.$gettext('Ok'),
        cancelButtonText: this.$gettext('Cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch(STORE_CONST.DASHBOARD.CUT_ONLINE, item.id).then(() => {
          /*
          let copy = Object.clone(this.currentConnectList)
          const deleteItem = copy.find((_item) => {
            return _item.id === item.id
          })
          copy.remove(deleteItem)
          this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT, copy)
          */
          let copyCount = Object.clone(this.$store.getters.dashboard.onlineMembersCount)
          this.$store.commit(STORE_CONST.DASHBOARD.LIST_ONLINE_CONNECT_COUNTS, copyCount - 1)
          this.getOnlineConnects()
          this.$notify({
            type: 'success',
            message: this.$gettext('Disconnect successfully!')
          })
        }).catch((err) => {
          this.$notify.info({
            message: err
          })
        })
      })
    }
  },
  watch: {
    languageCurrent: function (newVal, oldVal) {
      this.getWeekOperationStatistic()
    }
  },
  components: {
    Nvd3PieChart,
    Nvd3LineChart
  }
}
</script>
<style scoped lang="scss" rel="stylesheet/scss">
  @import "../../assets/css/variable";
  .content{
    padding: 15px;
  }
  .statistic-panel{
    background: #FFF;
    .statistic-item {
      padding: 30px;
      > div{
        /*cursor: pointer;*/
        i {
          font-size: 36px;
          /*color: #aaa;*/
          margin-bottom: 5px;
        }
        span.count{
          font-size: 24px;
        }
      }
      .assess-color{
        color: #5a96ff;
      }
      .work-color{
        color: #ffc770;
      }
      .cluster-color{
        color: #6cdaa1;
      }
      .member-color{
        color: #b48cf7;
      }
    }
  }
  .graph-panel{
    padding: 0px 0;
    .graph-item{
      background: #FFF;
      margin-top: 15px;
      /*border: 1px solid #ddd;*/
      .graph-item-header{
        line-height: 32px;
        padding: 5px 15px;
        border: 1px solid #ddd;
        border-bottom: 0;
        background: #F6F8F7;
      }
      .graph-item-content{
        height: 300px;
        .item{
          color: red;
        }
        a{
          color: $mainColor;
          &:hover{
            cursor: pointer;
          }
        }
        a[disabled]{
          color: $textColor;
          &:hover{
            cursor: not-allowed;
          }
        }
        &.chart{
          border: 1px solid #ddd;
        }
        .photo {
          /*display: inline-block;*/
          /*float: left;*/
          > img {
            width: 32px;
            height: 32px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            margin: 12px 5px 12px 0;
            float: left;
          }
          > span {
            /*position: relative;*/
            /*top: 15px;*/
            height: 56px;
            line-height: 56px;
            display: inline-block;
            width: 60%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
</style>
<style lang="scss" rel="stylesheet/scss">
  .graph-panel .el-table__body-wrapper {
    overflow: auto;
    position: relative;
    height: 260px;
    overflow-x: hidden;
  }
  .graph-item-210 .el-table__body-wrapper {
    height: 210px !important;
  }
</style>



// WEBPACK FOOTER //
// dashboard.vue?7fb4fa7b